import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

function initAccordions() {
  const accordions = document.querySelectorAll<HTMLElement>(".accordion");

  if (accordions.length < 1) return;
  accordions.forEach((accordion) => {
    const button = accordion.querySelector(
      ".accordion-toggle"
    ) as HTMLButtonElement;
    button && button.addEventListener("click", handleAccordionClick);
  });
}

function handleAccordionClick(event: MouseEvent) {
  const button = event.target.closest(".accordion-toggle") as HTMLButtonElement;
  console.log(button);
  const accordionIsOpen = button?.getAttribute("aria-expanded") === "true";
  const accordion = button.closest(".accordion");
  const accordionBody = accordion.querySelector(".accordion-body");
  // check if the accordion is in .event-calendar-list and speed up if it is

  if (gsap.isTweening(accordionBody)) return;

  if (accordionIsOpen) {
    // close it
    gsap.to(accordionBody, { duration: 0.25, height: 0 }).then(() => {
      accordionBody.hidden = "true";
      accordion.classList.remove("accordion--open");
    });
  } else {
    // open it
    accordionBody.hidden = !accordionBody.hidden;
    accordion.classList.add("accordion--open");
    gsap.set(accordionBody, { height: "auto" });
    gsap.from(accordionBody, { duration: 0.25, height: 0 });
  }

  button.setAttribute("aria-expanded", accordionIsOpen ? "false" : "true");

  // wait for animation to finish, then refresh scrolltriggers (for Impact Report)
  setTimeout(() => {
    if (!ScrollTrigger) return;
    ScrollTrigger.refresh();
  }, 250);
}

initAccordions();
